"use client"

import { useState } from "react"
import useScrollReveal from "../../hooks/useScrollReveal"
import "./FAQ.css"

const FAQ = ({ language }) => {
  useScrollReveal(".faq-item")
  const [openIndex, setOpenIndex] = useState(null)

  const faqData = {
    en: [
      {
        question: "Who is Governor Abba Kabir Yusuf?",
        answer:
          "Governor Abba Kabir Yusuf is the current governor of Kano State, Nigeria. He was elected on March 18, 2023, and sworn in on May 29, 2023. He is known for his focus on infrastructure development, education, healthcare, and youth empowerment.",
      },
      {
        question: "What are the main focus areas of the current administration?",
        answer:
          "The main focus areas include: Infrastructure Development (roads, flyovers, water supply), Education (facility upgrades, teacher support, scholarships), Healthcare (PHC revitalization, hospital upgrades), Youth Empowerment (electric tricycles, start-up kits), and Agricultural Support.",
      },
      {
        question: "How much has been invested in education?",
        answer:
          "Over ₦4.8 billion has been approved for renovating existing classrooms and constructing new ones across the 44 local government areas. In April 2025, the state budget allocated 31% to education, surpassing UNESCO recommendations.",
      },
      {
        question: "What infrastructure projects are ongoing?",
        answer:
          "Major projects include: Katsina Road expansion (₦24.7 billion), Flyovers and underpasses construction, Road rehabilitation (₦5.4 billion), Rural access roads (70 kilometers), and Market redevelopment (₦2 billion).",
      },
      {
        question: "How many healthcare centers are being renovated?",
        answer:
          "A total of 187 Primary Healthcare Centres across all 44 local government areas are being renovated and equipped. Additionally, 203 dilapidated PHCs are being renovated under the IMPACT Project.",
      },
      {
        question: "What is the youth empowerment program about?",
        answer:
          'The "Abba Gida Gida Mass Transport Empowerment and Employment Programme" includes the procurement of 500 electric tricycles valued at ₦3.7 billion. Over 1,130 graduates have also been provided with start-up kits.',
      },
      {
        question: "How many scholarships have been awarded?",
        answer:
          "The government has revived its foreign scholarship program, sponsoring 1,001 postgraduate students in various fields abroad. Outstanding school fees for students in foreign and local tertiary institutions have also been cleared.",
      },
      {
        question: "What awards has the governor received?",
        answer:
          "Governor Yusuf has received multiple awards including: Governor of the Year (Education), NUT Golden Award, Governor of the Year 2025 in Infrastructure Development, Fellowship Award from NICE, and African Good Governance Award 2025.",
      },
      {
        question: "What is the current state of agriculture in Kano?",
        answer:
          "The government has invested ₦2.5 billion in agricultural support programs, including fertilizer subsidies, tractor hiring services, and irrigation projects. Over 50,000 farmers have benefited from these initiatives, leading to increased crop yields and food security.",
      },
      {
        question: "How is the government addressing water supply issues?",
        answer:
          "Major investments include ₦15 billion for water infrastructure development, construction of new boreholes and water treatment plants, and rehabilitation of existing water systems. The goal is to provide clean water to all communities across the 44 local government areas.",
      },
      {
        question: "What initiatives are in place for women empowerment?",
        answer:
          "The administration has launched several programs including skills acquisition centers, micro-credit schemes, and cooperative societies. Over 25,000 women have been trained in various trades and provided with start-up capital to establish their own businesses.",
      },
      {
        question: "How is the government combating insecurity?",
        answer:
          "A comprehensive security strategy includes increased police presence, community policing initiatives, rehabilitation programs for ex-militants, and investment in intelligence gathering. The state has seen significant improvements in security with reduced crime rates.",
      },
      {
        question: "What is the status of the housing development program?",
        answer:
          "The government has approved ₦8 billion for affordable housing projects, with plans to construct 10,000 housing units across the state. Priority is given to low-income families, civil servants, and displaced persons.",
      },
      {
        question: "How many kilometers of roads have been constructed?",
        answer:
          "Over 200 kilometers of new roads have been constructed, and 500 kilometers of existing roads have been rehabilitated. The road network expansion continues with ₦12 billion allocated for additional road projects in the coming year.",
      },
      {
        question: "What environmental initiatives are being implemented?",
        answer:
          "The government has planted over 2 million trees as part of reforestation efforts, established waste management systems in major cities, and implemented clean energy projects. Environmental education programs have also been introduced in schools.",
      },
      {
        question: "How is the government supporting small businesses?",
        answer:
          "Through the Kano Enterprise Development Agency, over ₦3 billion has been disbursed as loans to small businesses. Business development training, mentorship programs, and market linkages have helped create thousands of jobs.",
      },
      {
        question: "What is the digital transformation strategy?",
        answer:
          "The government is implementing e-governance initiatives, digital literacy programs, and smart city technologies. Investment in ICT infrastructure includes broadband expansion and digital skills training for youth.",
      },
      {
        question: "How can residents provide feedback to the government?",
        answer:
          "Multiple channels are available including dedicated hotlines, online feedback forms, town hall meetings, and social media platforms. The government actively engages with citizens to ensure their voices are heard in decision-making processes.",
      },
    ],
    ha: [
      {
        question: "Gwamna Abba Kabir Yusuf shi ne wa?",
        answer:
          "Gwamna Abba Kabir Yusuf shine gwamna na yanzu na Jihar Kano, Nijeriya. An zabe shi a 18 Maris 2023, sannan an rantse shi a 29 Mayu 2023. An san shi saboda ƙaura da ya yi ga haɓaka gida, ilimi, lafiya, da karfafawa matasa.",
      },
      {
        question: "Menene manyan abubuwan da gwamnatin ta daidaita?",
        answer:
          "Manyan abubuwan sun haɗa da: Haɓaka Gida (hanyoyi, flyovers, ruwan sha), Ilimi (inganta gidajen ilimi, goyon bayan malamai, karatun kasua), Lafiya (farfadowa gidajen lafiya, inganta asibiti), Karfafawa Matasa (tricycles na lantarki, kayan fara aiki), da Goyon Bayan Noma.",
      },
      {
        question: "Nawa ne aka saka jari a ilimi?",
        answer:
          "Fiye da ₦4.8 billion an amince da shi don gyara dakin karatu da gina sabuwa a jihar 44 local government areas. A cikin Afirilu 2025, kasua jihar ta ba da 31% ga ilimi, wanda ya wuce shawarwarin UNESCO.",
      },
      {
        question: "Waɗannan ayyukan gida ne ke gudana?",
        answer:
          "Manyan ayyuka sun haɗa da: Faɗawar Katsina Road (₦24.7 billion), Gina flyovers da underpasses, Gyara hanyoyi (₦5.4 billion), Hanyoyi na kasuwa (70 kilometers), da Sabuntawa kasuwa (₦2 billion).",
      },
      {
        question: "Nawa ne gidajen lafiya da ake gyara?",
        answer:
          "Jiya 187 Primary Healthcare Centres a jihar 44 local government areas ana gyara da ba da kayan aiki. Kuma, gidajen lafiya 203 da suka lalace ana gyara su a ƙarƙar IMPACT Project.",
      },
      {
        question: "Menene tsarin karfafawa matasa?",
        answer:
          '"Abba Gida Gida Mass Transport Empowerment and Employment Programme" ya haɗa da siyan tricycles 500 na lantarki mai daraja na ₦3.7 billion. Dalibai fiye da 1,130 an kuma ba da kayan fara aiki.',
      },
      {
        question: "Nawa ne karatun kasua da aka ba?",
        answer:
          "Gwamnatin ta farfadowa da tsarin karatun kasua, tare da ba da kuɗi ga dalibai 1,001 na jiya a kasua daban-daban. An kuma gama biyan kuɗin karatun dalibai a kasua da gida.",
      },
      {
        question: "Waɗannan gidaje ne gwamna ya karɓa?",
        answer:
          "Gwamna Yusuf ya karɓa gidaje da yawa kamar: Governor of the Year (Education), NUT Golden Award, Governor of the Year 2025 in Infrastructure Development, Fellowship Award daga NICE, da African Good Governance Award 2025.",
      },
      {
        question: "Yaya yanayin noma yake a Kano yanzu?",
        answer:
          "Gwamnatin ta saka jari ₦2.5 billion a tsare-tsaren tallafin noma, wanda ya haɗa da rangwamen taki, hidimar haya tarakta, da ayyukan ban ruwa. Manoma fiye da 50,000 sun amfana daga waɗannan ayyuka, wanda ya haifar da karuwar amfanin amfanin ƙasa da tsaron abinci.",
      },
      {
        question: "Yaya gwamnatin ke magance matsalolin samar da ruwa?",
        answer:
          "Babban saka jari sun haɗa da ₦15 billion don haɓaka kayan aikin ruwa, gina boreholes sabuwa da masana'antar sarrafa ruwa, da gyara tsarin ruwa da ke akwai. Manufar ita ce samar da ruwa mai tsabta ga dukkan al'ummomi a jihar 44 local government areas.",
      },
      {
        question: "Waɗanne ayyuka ne ke akwai don karfafawa mata?",
        answer:
          "Gwamnatin ta ƙaddamar da tsare-tsare da yawa wanda ya haɗa da cibiyoyin koyon sana'o'i, tsare-tsaren micro-credit, da ƙungiyoyin haɗin gwiwa. Mata fiye da 25,000 an horar da su a sana'o'i daban-daban kuma an ba su jari don fara kasuwancinsu.",
      },
      {
        question: "Yaya gwamnatin ke yaƙi da rashin tsaro?",
        answer:
          "Tsarin tsaro mai cikakken ya haɗa da ƙara yawan 'yan sanda, ayyukan 'yan sanda na al'umma, tsare-tsaren gyarawa ga tsofaffin mayakan, da saka jari a tattara bayanai. Jihar ta ga ingantawa mai yawa a tsaro tare da rage yawan laifuka.",
      },
      {
        question: "Menene matsayin tsarin haɓaka gidaje?",
        answer:
          "Gwamnatin ta amince da ₦8 billion don ayyukan gidaje masu araha, tare da tsare-tsare don gina gidaje 10,000 a duk faɗin jihar. Ana ba da fifiko ga iyalai masu ƙarancin kuɗi, ma'aikatan gwamnati, da mutanen da suka rasa gidajensu.",
      },
      {
        question: "Nawa ne kilomita na hanyoyi da aka gina?",
        answer:
          "Fiye da kilomita 200 na hanyoyi sabuwa aka gina, kuma kilomita 500 na hanyoyi da ke akwai aka gyara. Faɗaɗa hanyoyin yana ci gaba tare da ₦12 billion da aka ware don ƙarin ayyukan hanyoyi a shekara mai zuwa.",
      },
      {
        question: "Waɗanne ayyukan muhalli ne ke aiwatarwa?",
        answer:
          "Gwamnatin ta dasa fiye da bishiyoyi miliyan 2 a matsayin ƙoƙarin sake dasa itatuwa, kafa tsarin sarrafa sharar a manyan birane, da aiwatar da ayyukan makamashi mai tsabta. An kuma gabatar da tsare-tsare na ilimin muhalli a makarantu.",
      },
      {
        question: "Yaya gwamnatin ke tallafa wa ƙananan kasuwanci?",
        answer:
          "Ta hanyar Kano Enterprise Development Agency, an rarraba fiye da ₦3 billion a matsayin lamuni ga ƙananan kasuwanci. Horar da haɓaka kasuwanci, tsare-tsare na jagoranci, da haɗin gwiwar kasuwa sun taimaka wajen ƙirƙirar dubban ayyuka.",
      },
      {
        question: "Menene tsarin canjin dijital?",
        answer:
          "Gwamnatin na aiwatar da ayyukan e-governance, tsare-tsare na karatun dijital, da fasahohin birni mai wayo. Saka jari a kayan aikin ICT ya haɗa da faɗaɗa broadband da horar da ƙwarewar dijital ga matasa.",
      },
      {
        question: "Yaya mazauna za su iya ba da ra'ayi ga gwamnatin?",
        answer:
          "Hanyoyi da yawa suna akwai wanda ya haɗa da layukan waya na musamman, fom na ra'ayi akan layi, tarurrukan zauren gaba, da dandamali na kafofin watsa labarai. Gwamnatin tana hulɗa da mazauna don tabbatar da cewa muryoyinsu ana jin su a cikin yanke shawara.",
      },
    ],
  }

  const currentFAQ = faqData[language]

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index)
  }

  return (
    <div className="faq">
      <div className="faq-header">
        <h1>{language === "en" ? "Frequently Asked Questions" : "Tambayoyin da aka bugi sau da yawa"}</h1>
      </div>

      <div className="faq-container">
        <div className="faq-list">
          {currentFAQ.map((item, index) => (
            <div key={index} className="faq-item scroll-reveal slide-left" style={{ animationDelay: `${index * 0.1}s` }}>
              <button
                className={`faq-question ${openIndex === index ? "active" : ""}`}
                onClick={() => toggleAccordion(index)}
              >
                <span>{item.question}</span>
                <span className="faq-icon">+</span>
              </button>
              {openIndex === index && (
                <div className="faq-answer">
                  <p>{item.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default FAQ
